module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/border-hover.d11d7498.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/border-hover.png
// module id = 2537
// module chunks = 11